class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }
}
customElements.define("m-footer", MFooter);

// JavaScript para o botão flutuante do WhatsApp
document.addEventListener('DOMContentLoaded', function() {
  
  // Configurações - ALTERE AQUI SEU NÚMERO
  const whatsappNumber = '5511976942083'; // Substitua pelo seu número com código do país
  const defaultMessage = 'Olá! Vim do seu site e gostaria de mais informações.';
  
  // Criar o botão do WhatsApp
  function createWhatsAppButton() {
    const whatsappButton = document.createElement('a');
    whatsappButton.href = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`;
    whatsappButton.className = 'whatsapp-float';
    whatsappButton.target = '_blank';
    whatsappButton.rel = 'noopener noreferrer';
    whatsappButton.innerHTML = `
      <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
      </svg>
    `;
    
    document.body.appendChild(whatsappButton);
    
    // Adicionar evento de clique para analytics (opcional)
    whatsappButton.addEventListener('click', function() {
      // Você pode adicionar código de tracking aqui
      console.log('WhatsApp button clicked');
      
      // Exemplo de Google Analytics (descomente se usar GA)
      // if (typeof gtag !== 'undefined') {
      //   gtag('event', 'click', {
      //     'event_category': 'WhatsApp',
      //     'event_label': 'Floating Button'
      //   });
      // }
    });
  }
  
  // Remover botão de voltar ao topo existente
  function removeBackToTopButton() {
    const selectors = [
      '.back-to-top',
      '.scroll-to-top', 
      '.return-to-top',
      '[data-scroll-to-top]',
      '.btn-scroll-top',
      '.scroll-up',
      '.go-to-top'
    ];
    
    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.style.display = 'none';
      });
    });
  }
  
  // Inicializar
  removeBackToTopButton();
  createWhatsAppButton();
  
  // Verificar novamente após um pequeno delay para elementos carregados dinamicamente
  setTimeout(() => {
    removeBackToTopButton();
  }, 1000);
});
